import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M9 8H19" stroke={color} strokeWidth="2" />
    <path d="M5 8H7" stroke={color} strokeWidth="2" />
    <path d="M9 12H19" stroke={color} strokeWidth="2" />
    <path d="M5 12H7" stroke={color} strokeWidth="2" />
    <path d="M9 16H19" stroke={color} strokeWidth="2" />
    <path d="M5 16H7" stroke={color} strokeWidth="2" />
  </svg>
);
